import * as React from 'react'

export interface ExpandableProps {
  isExpanded: boolean
  toggleExpand: () => void
}

// Expandable higher order component.
//
// If you want a component to have an expand/collapse or show/hide toggle, use this to track toggle state.
//
// Example:
//
// function MyListImpl({ isExpanded, toggleExpand, myItems }: props) {
//   return (
//     <div>
//       {isExpanded && myItems.map(i => <Row item={i} />)}
//       <button onClick={toggleExpand}>{isExpanded ? 'Collapse' : 'Expand'}</button>
//     </div>
//   )
// }
//
// const MyList = expandable(MyListImpl)
//
// Now you can use:
//
// <MyList myItems={items} />
//
// ... and you get a expandable list, hidden by default.
//
// You can also show eg top 5, click to expand the rest, etc.

export default function expandable<T>(Component: React.ComponentType<T & ExpandableProps>): React.ComponentType<T> {
  return class Expandable extends React.PureComponent<T, { isExpanded: boolean }> {
    constructor(props: T) {
      super(props)
      this.state = { isExpanded: false }
    }

    render() {
      const { isExpanded } = this.state
      return <Component isExpanded={isExpanded} toggleExpand={this.toggleExpandBound} {...this.props} />
    }

    private toggleExpandBound = () => this.setState({ isExpanded: !this.state.isExpanded })
  }
}
